import { sort_center_api } from '@shared/api';
import { ActionBagCodesRequest, GetAllBagCodesHttpResponse, GetAllChutesHttpResponse } from '../model/sortingSettings';
import { DefaultSimpleResponse } from '@shared/types/api';

export async function getChutes(): Promise<GetAllChutesHttpResponse> {
  const url = 'v1/chutes';
  const res = await sort_center_api<GetAllChutesHttpResponse>(url);
  return res.data;
}

export async function getBagCodes(): Promise<GetAllBagCodesHttpResponse> {
  const url = 'v1/sorting-directory/bag-codes';
  const res = await sort_center_api<GetAllBagCodesHttpResponse>(url);
  return res.data;
}

export async function addBagCodes(data: ActionBagCodesRequest): Promise<DefaultSimpleResponse> {
  const url = 'v1/chutes/add-bag-code';
  const res = await sort_center_api.post<DefaultSimpleResponse>(url, data);
  return res.data;
}

export async function removeBagCodes(data: ActionBagCodesRequest): Promise<DefaultSimpleResponse> {
  const url = 'v1/chutes/remove-bag-code';
  const res = await sort_center_api.post<DefaultSimpleResponse>(url, data);
  return res.data;
}

export async function removeAllDataFromChute(chuteId: number): Promise<DefaultSimpleResponse> {
  const url = 'v1/chutes/remove-all-bag-code';
  const res = await sort_center_api.post<DefaultSimpleResponse>(url, { chuteId });
  return res.data;
}
